import { AWSLogo } from "@/assets/logos/AWSLogo";
import { AppleSiliconLogo } from "@/assets/logos/AppleSiliconLogo";
import { GCPLogo } from "@/assets/logos/GCPLogo";
import { LinuxLogo } from "@/assets/logos/LinuxLogo";
import { cn, type PropsWithClassName } from "@/components/podkit/lib/cn";
import type { PlainRunner } from "@/queries/runner-queries";
import { RunnerProvider } from "gitpod-next-api/gitpod/v1/runner_configuration_pb";
import { CloudIcon } from "lucide-react";
import type { FC } from "react";

export const RunnerIcon: FC<PropsWithClassName & { runner?: PlainRunner }> = ({ runner, className }) => {
    const classes = cn("h-8 w-8 text-content-primary", className);

    if (!runner) {
        return <CloudIcon className={classes} />;
    }

    switch (runner.provider) {
        case RunnerProvider.AWS_EC2:
            return <AWSLogo className={classes} />;
        case RunnerProvider.GCP:
            return <GCPLogo className={classes} />;
        case RunnerProvider.DESKTOP_MAC:
            return <AppleSiliconLogo className={classes} />;
        case RunnerProvider.LINUX_HOST:
            return <LinuxLogo className={classes} />;
        case RunnerProvider.MANAGED:
            return <CloudIcon className={classes} />;
        default:
            return <CloudIcon className={classes} />;
    }
};
